// extracted by mini-css-extract-plugin
export var open = "languageButton-module--open--uBCE+";
export var section = "languageButton-module--section--njkwv";